import styled from 'styles/styled';

export const SeeDetailsLink = styled.a`
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #52D381;
  text-align: center;
  margin: 12px auto 0 auto;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 720px) {
    font-size: 15px;
  }
`;

export const CheckmarkIcon = styled.div`
  font-size: 40px;
  color: #52D381;
  text-align: center;
  margin: 18px auto 0 auto;
  line-height: 1;
`;

export const GasFeeRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const GasFeeLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #EFEFEF;
  width: 50%;
  text-align: right;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const GasFeeValue = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #52D381;
  width: 50%;
  text-align: left;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;
